// First API Layer of reinsurance
import { general } from './general'

export const actions = Object.assign({}, general)
